import React from "react";
import {
  FaUsers,
  FaProjectDiagram,
  FaExclamationCircle,
  FaChartLine,
  FaHeadset,
  FaAddressBook,
  FaHome,
  FaLock,
  FaUserTie,
  FaWallet,
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
} from "react-icons/fa";
import "../assets/css/Sidebar.css";
import { getCurrentUserRole, getAllowedSidebarPages } from "../utils/roleAccess";

// Internal page ids – must match `PAGES` in roleAccess and `App` routing logic
const ALL_MENU_ITEMS = [
  "Dashboard",
  "Users",
  "Projects",
  "Issues",
  "DigixLeads",
  "Clients",
  "HRManagement",
  "FinanceManagement",
  "Accounts",
  "Support Contacts"
];

// Display labels and icons for sidebar
const PAGE_LABELS = {
  "Users": "Employees",
  "Projects": "Project Management",
  "Issues": "Issue Tracker",
  "DigixLeads": "DigiXLeads",
  "Clients": "Clients",
  "Accounts": "ConnectVault",
  "HRManagement": "HR Management",
  "FinanceManagement": "Finance Management",
  "Support Contacts": "Support",
};

const PAGE_ICONS = {
  "Dashboard": FaHome,
  "Users": FaUsers,
  "Projects": FaProjectDiagram,
  "Issues": FaExclamationCircle,
  "DigixLeads": FaChartLine,
  "Clients": FaAddressBook,
  "Accounts": FaLock,
  "HRManagement": FaUserTie,
  "FinanceManagement": FaWallet,
  "Support Contacts": FaHeadset,
};

function Sidebar({ activePage, onNavigate, isOpen = false, collapsed = false, onToggleCollapse }) {
  const role = getCurrentUserRole();
  const allowedPages = getAllowedSidebarPages(role);
  const menuItems = ALL_MENU_ITEMS.filter((item) => allowedPages.includes(item));

  return (
    <div
      className={`sidebar${isOpen ? " is-open" : ""}${collapsed ? " is-collapsed" : ""}`}
    >
      <div className="sidebar-header">
        <div className="sidebar-logo" title="CLOUD OFFICE (AI)">
          {collapsed ? "CO" : "CLOUD OFFICE (AI)"}
        </div>
        {onToggleCollapse && (
          <button
            type="button"
            className="sidebar-collapse-btn"
            onClick={onToggleCollapse}
            aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          >
            {collapsed ? <FaAngleDoubleRight size={14} /> : <FaAngleDoubleLeft size={14} />}
          </button>
        )}
      </div>
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const Icon = PAGE_ICONS[item];
          const label = PAGE_LABELS[item] || item;
          return (
            <div
              key={item}
              className={`nav-item ${activePage === item ? "active" : ""}`}
              onClick={() => onNavigate && onNavigate(item)}
              title={label}
            >
              {Icon && <Icon className="nav-item-icon" />}
              <span className="nav-item-label">{label}</span>
            </div>
          );
        })}
      </nav>
    </div>
  );
}

export default Sidebar;
